<script setup>
import { computed, defineExpose, ref } from 'vue';

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  variant: {
    type: String,
    default: 'primary',
  },
  busyHideMessage: {
    type: Boolean,
    default: false,
  },
});

const getVariant = computed({
  get: () => (props.variant ? `btn-${props.variant}` : 'btn-primary'),
});

const baseClass = computed({
  get() {
    return [
      'btn',
      'waves-effect',
      'waves-float',
      'waves-light',
      getVariant.value,
    ];
  },
});

const busy = ref(false);

function lock() {
  busy.value = true;
}

function unlock() {
  busy.value = false;
}

defineExpose({
  lock,
  unlock,
});
</script>

<template>
  <button type="button" :class="baseClass" :disabled="busy" >
    <slot v-if="busy" name="loading">
      <span class="spinner-border spinner-border-sm me" role="status" aria-hidden="true" />
    </slot>
    <slot v-if="(busy && !busyHideMessage) || !busy">{{ props.title }}</slot>
  </button>
</template>

<style scoped>
  .me {
    margin-right: 4px;
  }
</style>
